import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Card';
import api from '@/api';
import toast from 'react-hot-toast';

const InputField = ({ label, type = 'text', name, value, onChange }) => (
    <div>
        <label htmlFor={name} className="block text-sm font-medium text-pro-dark-text-secondary">{label}</label>
        <input type={type} name={name} id={name} value={value} onChange={onChange} className="mt-1 w-full p-2 bg-pro-dark-surface border border-pro-dark-border rounded-md focus:ring-pro-dark-accent focus:border-pro-dark-accent"/>
    </div>
);

const AjouterOffrePage = () => {
    const [formData, setFormData] = useState({});
    const [fileToUpload, setFileToUpload] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoadingFile, setIsLoadingFile] = useState(false);
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
        const finalValue = type === 'number' && value !== '' ? parseInt(value, 10) : value;
        setFormData(prev => ({ ...prev, [name]: finalValue }));
    };

    const handleFileChangeForIA = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setIsLoadingFile(true);
        const loadingToast = toast.loading('Analyse du document en cours...');
        const uploadData = new FormData();
        uploadData.append('file', file);
        try {
            const response = await api.post('/offres/extract-from-file', uploadData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setFormData(response.data);
            toast.success('Formulaire pré-rempli !', { id: loadingToast });
        } catch (error) {
            console.error("Erreur lors de l'extraction des données de l'offre:", error);
            toast.error("Impossible d'analyser le document.", { id: loadingToast });
        } finally {
            setIsLoadingFile(false);
        }
    };

    // CORRECTION : Ajout de la fonction manquante
    const handleFileChangeForUpload = (event) => {
        setFileToUpload(event.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        const submissionData = new FormData();
        submissionData.append('formData', JSON.stringify(formData));
        if (fileToUpload) {
            submissionData.append('attachment_file', fileToUpload);
        }
        try {
            await api.post('/offres/', submissionData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success('Appel d\'offre ajouté avec succès !');
            navigate('/offres');
        } catch (error) {
            console.error("Erreur lors de l'ajout de l'offre:", error.response?.data);
            toast.error(`Une erreur est survenue: ${error.response?.data?.detail || 'Erreur inconnue'}`);
        } finally {
            setIsSaving(false);
        }
    };

    const fields = [
        { label: 'Date Collaboration', name: 'dateCollaboration', type: 'date' }, { label: 'Compte', name: 'compte' },
        { label: 'Secteur', name: 'secteur' }, { label: 'Numéro Référence', name: 'numeroReference' },
        { label: 'Numéro BH', name: 'numeroBH' }, { label: 'Donneur D\'ordre', name: 'donneurDordre' },
        { label: 'TJM Annoncé', name: 'tjmAnnonce', type: 'number' }, { label: 'Niveau Exp', name: 'niveauExp' },
        { label: 'Solution', name: 'solution' }, { label: 'Statut', name: 'statut' },
    ];

  return (
    <div>
        <h1 className="text-3xl font-bold text-pro-dark-text-primary mb-8">Ajouter un appel d'offre</h1>
        <Card title="Pré-remplir avec un fichier">
            <p className="text-pro-dark-text-secondary mb-4">Importez un fichier (PDF, DOCX) pour que l'IA remplisse le formulaire.</p>
            <input type="file" onChange={handleFileChangeForIA} disabled={isLoadingFile} accept=".pdf,.docx" className="text-sm text-pro-dark-text-secondary file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-pro-dark-accent file:text-white hover:file:bg-pro-dark-accent-hover"/>
            {isLoadingFile && <p className="text-pro-dark-accent animate-pulse mt-2">Analyse du document en cours...</p>}
        </Card>
        <div className="my-8 text-center text-pro-dark-text-secondary"><span className="bg-pro-dark-surface px-2">OU</span></div>
        <Card title="Remplir manuellement">
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {fields.map(field => (
                    <InputField key={field.name} {...field} value={formData[field.name] || ''} onChange={handleInputChange} />
                ))}
                <div className="md:col-span-3">
                    <label htmlFor="detailDuBesoin" className="block text-sm font-medium text-pro-dark-text-secondary">Détail du Besoin</label>
                    <textarea id="detailDuBesoin" name="detailDuBesoin" rows="4" value={formData.detailDuBesoin || ''} onChange={handleInputChange} className="mt-1 w-full p-2 bg-pro-dark-surface border border-pro-dark-border rounded-md focus:ring-pro-dark-accent focus:border-pro-dark-accent"></textarea>
                </div>
                <div className="md:col-span-3">
                    <label htmlFor="commentaire" className="block text-sm font-medium text-pro-dark-text-secondary">Commentaire</label>
                    <textarea id="commentaire" name="commentaire" rows="4" value={formData.commentaire || ''} onChange={handleInputChange} className="mt-1 w-full p-2 bg-pro-dark-surface border border-pro-dark-border rounded-md focus:ring-pro-dark-accent focus:border-pro-dark-accent"></textarea>
                </div>
                <div className="md:col-span-3">
                    <label className="block text-sm font-medium text-pro-dark-text-secondary">Joindre un fichier (pour sauvegarde)</label>
                    <input type="file" onChange={handleFileChangeForUpload} accept=".pdf,.docx" className="mt-1 w-full text-sm text-pro-dark-text-secondary file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-pro-dark-surface file:text-white hover:file:bg-pro-dark-border"/>
                </div>
                <div className="md:col-span-3 text-right">
                    <button type="submit" disabled={isSaving} className="px-6 py-2 bg-pro-dark-accent text-white rounded-lg hover:bg-pro-dark-accent-hover disabled:bg-gray-600">
                    {isSaving ? 'Sauvegarde...' : 'Sauvegarder'}
                    </button>
                </div>
            </form>
        </Card>
    </div>
  );
};

export default AjouterOffrePage;